import { Link } from "react-router-dom";
import ProcurementOrderStatusBadge from "./ProcurementOrderStatusBadge";
import ProcurementOrderProcessingActions from "./ProcurementOrderProcessingActions";
import ProcurementOrderAssociationBadge from "./ProcurementOrderAssociationBadge";

function formatDate(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("nl-NL");
}

export default function ProcurementProcessingTable({
  items = [],
  loading = false,
  busyId = "",
  onAction,
}) {
  return (
    <section className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-slate-200 text-sm">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-500">
            <tr>
              <th className="px-4 py-2">Order</th>
              <th className="px-4 py-2">Status</th>
              <th className="px-4 py-2">Type</th>
              <th className="px-4 py-2">Hoort bij</th>
              <th className="px-4 py-2">Leverancier</th>
              <th className="px-4 py-2">Aangevraagd door</th>
              <th className="px-4 py-2">Acties</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {!loading && items.length === 0 && (
              <tr>
                <td className="px-4 py-6 text-slate-500" colSpan={7}>Geen orders te verwerken.</td>
              </tr>
            )}
            {items.map((item) => (
              <tr key={item._id} className="hover:bg-slate-50">
                <td className="px-4 py-2">
                  <Link to={`/pl/inkoop/${item._id}`} className="font-medium text-slate-900 hover:underline">
                    {item.orderNumber || "PO"}
                  </Link>
                  <p className="text-xs text-slate-500">{item.title}</p>
                  <p className="text-xs text-slate-500">{formatDate(item.createdAt)}</p>
                </td>
                <td className="px-4 py-2">
                  <ProcurementOrderStatusBadge
                    status={item.status}
                    displayStatus={item.displayStatus || item.displayStatusKey}
                    label={item.displayStatusLabel}
                  />
                  <p className="mt-1 text-xs text-slate-500">{item.nextActionLabel || "-"}</p>
                </td>
                <td className="px-4 py-2 text-slate-700">{item.type}</td>
                <td className="px-4 py-2">
                  <ProcurementOrderAssociationBadge associationType={item.associationType} />
                </td>
                <td className="px-4 py-2 text-slate-700">{item.supplierName || "-"}</td>
                <td className="px-4 py-2 text-xs text-slate-600">
                  <p>{item.createdBy?.name || "-"}</p>
                  <p>{item.createdBy?.email || "-"}</p>
                </td>
                <td className="px-4 py-2">
                  <ProcurementOrderProcessingActions
                    status={item.normalizedStatus || item.status}
                    disabled={busyId === item._id}
                    onAction={(actionKey) => onAction?.(item, actionKey)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
